import React, { useState } from "react";
import PropTypes from "prop-types";
import { timeStampFormat } from "../../../utils/common/index";
import PrimarySales from "./component/primarySales";
import SalesView from "../../../views/rechargeSales/sales";
import { getSectionKeyFromTileName, getSectionKeyFromTileIndex } from "../../../utils/rechargeSalesInsights";


const RenderPanel = (props) => {
  let { tileName, ...other } = props;
  return <PrimarySales data="" tileName={tileName} {...other} />;
};
RenderPanel.propTypes = {
  tileName: PropTypes.string,
};

const Sales = (props) => {
  const [sideValue, setSideValue] = useState(0);
  const { timeStampArr } = props;
  props.data &&
    props.data.sort((a, b) => {
      return a.tileId - b.tileId;
    });

  const sideHandleChangeDesktop = (tile, event) => {
    setSideValue(event);
  };

  let ts = "";
  const activeTiles = (props.data || []).filter((tile) => tile.isTileActive === "Y");
  const currSelectedTile = activeTiles[sideValue]?.tileName;
  const insightsSection =
    getSectionKeyFromTileName(currSelectedTile) || getSectionKeyFromTileIndex(sideValue);
  if (timeStampArr) {
    ts = timeStampArr.filter((data) => {
      return data?.tilename?.toLowerCase() === currSelectedTile?.toLowerCase();
    });
    ts = timeStampFormat(
      ts && ts[0] && ts[0].tileTimestamp && ts[0].tileTimestamp?.split(".")[0]
    );
  }
return (
    <SalesView
      data={props.data}
      sideHandleChangeDesktop={sideHandleChangeDesktop}
      setSideValue={setSideValue}
      sideValue={sideValue}
      ts={ts}
      RenderPanel={RenderPanel}
      filterValue={props.filterValue}
      currSelectedTile={currSelectedTile}
      startDate={props.startDate}
      endDate={props.endDate}
      moduleName={props.moduleName}
      section={props.section}
      insightsSection={insightsSection}
    />
  );


}

export default Sales;
